var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestopsStep5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 270,
    viewBox: "0 0 562 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_933_48438",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 562,
    height: 270
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 270,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_933_48438)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 206.061,
    height: 86.6519,
    rx: 9.28571,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 46H551C555.971 46 560 50.0294 560 55V285H1V46Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7404,
    y: 143.404,
    width: 12.9186,
    height: 11.7125,
    stroke: "#BDBDBD",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7404,
    y: 175.066,
    width: 12.9186,
    height: 11.7125,
    stroke: "#BDBDBD",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7404,
    y: 208.365,
    width: 12.9186,
    height: 11.7125,
    stroke: "#BDBDBD",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7404,
    y: 241.665,
    width: 12.9186,
    height: 11.7125,
    stroke: "#BDBDBD",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7404,
    y: 113.552,
    width: 12.9186,
    height: 11.7125,
    stroke: "black",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6758 118.832L38.5973 121.191L43.3195 116.368",
    stroke: "black",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 66,
    width: 96,
    height: 25,
    rx: 4,
    fill: "#E5EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.625 77.75C50.8125 77.75 51 77.9375 51 78.125V78.875C51 79.0859 50.8125 79.25 50.625 79.25H47.25V82.625C47.25 82.8359 47.0625 83 46.875 83H46.125C45.9141 83 45.75 82.8359 45.75 82.625V79.25H42.375C42.1641 79.25 42 79.0859 42 78.875V78.125C42 77.9375 42.1641 77.75 42.375 77.75H45.75V74.375C45.75 74.1875 45.9141 74 46.125 74H46.875C47.0625 74 47.25 74.1875 47.25 74.375V77.75H50.625Z",
    fill: "#22283C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 78,
    width: 56,
    height: 2,
    fill: "#22283C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0986 19.5302V17.9109H77.7476V19.5302H73.8575V30.3784H71.9825V19.5302H68.0986ZM82.4077 30.5671C81.4864 30.5671 80.693 30.3703 80.0274 29.9766C79.3659 29.5789 78.8545 29.0209 78.4933 28.3025C78.1362 27.5801 77.9576 26.7339 77.9576 25.764C77.9576 24.8062 78.1362 23.962 78.4933 23.2315C78.8545 22.501 79.3577 21.9308 80.003 21.5209C80.6524 21.111 81.4113 20.906 82.2798 20.906C82.8074 20.906 83.3188 20.9933 83.8139 21.1678C84.309 21.3423 84.7534 21.6162 85.1471 21.9896C85.5408 22.363 85.8513 22.848 86.0785 23.4446C86.3058 24.0371 86.4194 24.7575 86.4194 25.6057V26.251H78.9864V24.8873H84.6357C84.6357 24.4085 84.5383 23.9843 84.3435 23.615C84.1487 23.2417 83.8748 22.9474 83.5217 22.7323C83.1727 22.5172 82.7628 22.4097 82.292 22.4097C81.7806 22.4097 81.3342 22.5355 80.9527 22.7871C80.5753 23.0347 80.2831 23.3593 80.0761 23.7611C79.8732 24.1589 79.7717 24.5911 79.7717 25.0578V26.1231C79.7717 26.7481 79.8813 27.2798 80.1004 27.7181C80.3237 28.1564 80.6341 28.4912 81.0319 28.7226C81.4296 28.9498 81.8943 29.0635 82.4259 29.0635C82.7709 29.0635 83.0854 29.0148 83.3695 28.9174C83.6536 28.8159 83.8991 28.6658 84.1061 28.4669C84.3131 28.268 84.4714 28.0225 84.581 27.7303L86.3038 28.0408C86.1658 28.5481 85.9182 28.9925 85.5611 29.374C85.208 29.7514 84.7636 30.0456 84.2279 30.2567C83.6962 30.4636 83.0895 30.5671 82.4077 30.5671ZM95.4459 23.3106L93.7962 23.6029C93.7272 23.3918 93.6176 23.1909 93.4674 23.0002C93.3213 22.8094 93.1225 22.6532 92.8708 22.5314C92.6192 22.4097 92.3047 22.3488 91.9272 22.3488C91.4118 22.3488 90.9816 22.4645 90.6367 22.6958C90.2917 22.9231 90.1192 23.2173 90.1192 23.5785C90.1192 23.891 90.2349 24.1426 90.4662 24.3334C90.6975 24.5241 91.0709 24.6804 91.5863 24.8021L93.0717 25.143C93.9321 25.3419 94.5733 25.6483 94.9954 26.0623C95.4175 26.4762 95.6285 27.014 95.6285 27.6755C95.6285 28.2356 95.4662 28.7347 95.1415 29.1731C94.8209 29.6073 94.3725 29.9482 93.7962 30.1958C93.2239 30.4434 92.5604 30.5671 91.8055 30.5671C90.7584 30.5671 89.9041 30.3439 89.2426 29.8975C88.5811 29.447 88.1752 28.8078 88.0251 27.9799L89.7844 27.712C89.894 28.1706 90.1192 28.5176 90.4601 28.753C90.801 28.9843 91.2454 29.1 91.7933 29.1C92.3899 29.1 92.8668 28.9762 93.2239 28.7287C93.5811 28.477 93.7596 28.1706 93.7596 27.8094C93.7596 27.5172 93.6501 27.2717 93.4309 27.0728C93.2158 26.874 92.885 26.7238 92.4386 26.6223L90.8558 26.2753C89.9833 26.0765 89.338 25.7599 88.9199 25.3257C88.506 24.8914 88.299 24.3415 88.299 23.6759C88.299 23.124 88.4532 22.641 88.7617 22.227C89.0701 21.8131 89.4962 21.4904 90.0401 21.2591C90.5839 21.0237 91.2069 20.906 91.909 20.906C92.9195 20.906 93.715 21.1252 94.2953 21.5635C94.8757 21.9977 95.2592 22.5801 95.4459 23.3106ZM101.995 21.0278V22.4888H96.8872V21.0278H101.995ZM98.2569 18.7875H100.077V27.6329C100.077 27.986 100.13 28.2518 100.235 28.4304C100.341 28.6049 100.477 28.7246 100.643 28.7895C100.814 28.8504 100.998 28.8809 101.197 28.8809C101.343 28.8809 101.471 28.8707 101.581 28.8504C101.69 28.8301 101.776 28.8139 101.836 28.8017L102.165 30.3054C102.06 30.346 101.909 30.3865 101.715 30.4271C101.52 30.4718 101.276 30.4961 100.984 30.5002C100.505 30.5083 100.059 30.4231 99.6449 30.2445C99.2309 30.0659 98.8961 29.7899 98.6404 29.4166C98.3847 29.0432 98.2569 28.5744 98.2569 28.0103V18.7875ZM115.552 23.3106L113.902 23.6029C113.833 23.3918 113.724 23.1909 113.573 23.0002C113.427 22.8094 113.228 22.6532 112.977 22.5314C112.725 22.4097 112.411 22.3488 112.033 22.3488C111.518 22.3488 111.088 22.4645 110.743 22.6958C110.398 22.9231 110.225 23.2173 110.225 23.5785C110.225 23.891 110.341 24.1426 110.572 24.3334C110.804 24.5241 111.177 24.6804 111.692 24.8021L113.178 25.143C114.038 25.3419 114.679 25.6483 115.101 26.0623C115.524 26.4762 115.735 27.014 115.735 27.6755C115.735 28.2356 115.572 28.7347 115.248 29.1731C114.927 29.6073 114.478 29.9482 113.902 30.1958C113.33 30.4434 112.666 30.5671 111.912 30.5671C110.864 30.5671 110.01 30.3439 109.349 29.8975C108.687 29.447 108.281 28.8078 108.131 27.9799L109.89 27.712C110 28.1706 110.225 28.5176 110.566 28.753C110.907 28.9843 111.351 29.1 111.899 29.1C112.496 29.1 112.973 28.9762 113.33 28.7287C113.687 28.477 113.866 28.1706 113.866 27.8094C113.866 27.5172 113.756 27.2717 113.537 27.0728C113.322 26.874 112.991 26.7238 112.545 26.6223L110.962 26.2753C110.089 26.0765 109.444 25.7599 109.026 25.3257C108.612 24.8914 108.405 24.3415 108.405 23.6759C108.405 23.124 108.559 22.641 108.868 22.227C109.176 21.8131 109.602 21.4904 110.146 21.2591C110.69 21.0237 111.313 20.906 112.015 20.906C113.026 20.906 113.821 21.1252 114.401 21.5635C114.982 21.9977 115.365 22.5801 115.552 23.3106ZM123.659 26.5006V21.0278H125.485V30.3784H123.696V28.7591H123.598C123.383 29.2583 123.038 29.6743 122.563 30.0071C122.093 30.3358 121.506 30.5002 120.804 30.5002C120.203 30.5002 119.672 30.3683 119.209 30.1045C118.75 29.8366 118.389 29.4409 118.125 28.9174C117.866 28.3938 117.736 27.7465 117.736 26.9754V21.0278H119.556V26.7563C119.556 27.3934 119.733 27.9007 120.086 28.2782C120.439 28.6556 120.897 28.8443 121.462 28.8443C121.802 28.8443 122.141 28.7591 122.478 28.5886C122.819 28.4182 123.101 28.1605 123.324 27.8155C123.552 27.4705 123.663 27.0322 123.659 26.5006ZM127.931 30.3784V21.0278H129.751V30.3784H127.931ZM128.85 19.585C128.534 19.585 128.262 19.4795 128.035 19.2684C127.811 19.0533 127.7 18.7977 127.7 18.5014C127.7 18.2011 127.811 17.9454 128.035 17.7343C128.262 17.5193 128.534 17.4117 128.85 17.4117C129.167 17.4117 129.437 17.5193 129.66 17.7343C129.887 17.9454 130.001 18.2011 130.001 18.5014C130.001 18.7977 129.887 19.0533 129.66 19.2684C129.437 19.4795 129.167 19.585 128.85 19.585ZM136.565 21.0278V22.4888H131.457V21.0278H136.565ZM132.827 18.7875H134.647V27.6329C134.647 27.986 134.7 28.2518 134.806 28.4304C134.911 28.6049 135.047 28.7246 135.214 28.7895C135.384 28.8504 135.569 28.8809 135.768 28.8809C135.914 28.8809 136.041 28.8707 136.151 28.8504C136.261 28.8301 136.346 28.8139 136.407 28.8017L136.735 30.3054C136.63 30.346 136.48 30.3865 136.285 30.4271C136.09 30.4718 135.847 30.4961 135.554 30.5002C135.076 30.5083 134.629 30.4231 134.215 30.2445C133.801 30.0659 133.466 29.7899 133.211 29.4166C132.955 29.0432 132.827 28.5744 132.827 28.0103V18.7875ZM142.508 30.5671C141.587 30.5671 140.793 30.3703 140.128 29.9766C139.466 29.5789 138.955 29.0209 138.594 28.3025C138.237 27.5801 138.058 26.7339 138.058 25.764C138.058 24.8062 138.237 23.962 138.594 23.2315C138.955 22.501 139.458 21.9308 140.103 21.5209C140.753 21.111 141.512 20.906 142.38 20.906C142.908 20.906 143.419 20.9933 143.914 21.1678C144.409 21.3423 144.854 21.6162 145.248 21.9896C145.641 22.363 145.952 22.848 146.179 23.4446C146.406 24.0371 146.52 24.7575 146.52 25.6057V26.251H139.087V24.8873H144.736C144.736 24.4085 144.639 23.9843 144.444 23.615C144.249 23.2417 143.975 22.9474 143.622 22.7323C143.273 22.5172 142.863 22.4097 142.392 22.4097C141.881 22.4097 141.435 22.5355 141.053 22.7871C140.676 23.0347 140.383 23.3593 140.177 23.7611C139.974 24.1589 139.872 24.5911 139.872 25.0578V26.1231C139.872 26.7481 139.982 27.2798 140.201 27.7181C140.424 28.1564 140.735 28.4912 141.132 28.7226C141.53 28.9498 141.995 29.0635 142.526 29.0635C142.871 29.0635 143.186 29.0148 143.47 28.9174C143.754 28.8159 144 28.6658 144.207 28.4669C144.414 28.268 144.572 28.0225 144.681 27.7303L146.404 28.0408C146.266 28.5481 146.019 28.9925 145.661 29.374C145.308 29.7514 144.864 30.0456 144.328 30.2567C143.797 30.4636 143.19 30.5671 142.508 30.5671Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.8242,
    y: 13.3096,
    width: 19.8176,
    height: 17.7068,
    fill: "#276EF1",
    stroke: "black",
    strokeWidth: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.8022,
    y: 16.9267,
    width: 19.8205,
    height: 17.7098,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 1.28708
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7075 20.3564H47.7632",
    stroke: "#212121",
    strokeWidth: 1.28708
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7075 25.7915H47.7632",
    stroke: "#212121",
    strokeWidth: 1.28708
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.376 31.074H47.5932",
    stroke: "#212121",
    strokeWidth: 1.28708
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6029,
    y: 19.4254,
    width: 2.15823,
    height: 1.85669,
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6029,
    y: 24.8529,
    width: 2.15823,
    height: 1.85669,
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6029,
    y: 30.2809,
    width: 2.15823,
    height: 1.85669,
    fill: "#212121",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.0247,
    y: 113.506,
    width: 10.9602,
    height: 9.77822,
    fill: "#276EF1",
    stroke: "black",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7723,
    y: 115.531,
    width: 10.9631,
    height: 9.78108,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5703 117.384H76.6415",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5703 120.427H76.6415",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9453 123.385H76.547",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 116.623,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 119.662,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 122.701,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.281,
    y: 116.695,
    width: 58.2972,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4561,
    y: 116.524,
    width: 93.4765,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.142,
    y: 116.695,
    width: 58.2972,
    height: 5.42767,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.0247,
    y: 144.263,
    width: 10.9602,
    height: 9.77822,
    fill: "#276EF1",
    stroke: "black",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7723,
    y: 146.288,
    width: 10.9631,
    height: 9.78108,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5703 148.141H76.6415",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5703 151.184H76.6415",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9453 154.142H76.547",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 147.379,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 150.419,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 153.458,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.281,
    y: 147.451,
    width: 49.251,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4561,
    y: 147.281,
    width: 72.3689,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.142,
    y: 147.451,
    width: 58.2972,
    height: 5.42767,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.0247,
    y: 175.02,
    width: 10.9602,
    height: 9.77822,
    fill: "#276EF1",
    stroke: "black",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7723,
    y: 177.045,
    width: 10.9631,
    height: 9.78108,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5703 178.897H76.6415",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5703 181.941H76.6415",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9453 184.899H76.547",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 178.136,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 181.176,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 184.215,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.281,
    y: 178.208,
    width: 39.1998,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4561,
    y: 178.037,
    width: 108.553,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.142,
    y: 178.208,
    width: 58.2972,
    height: 5.42767,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.0252,
    y: 208.319,
    width: 10.9602,
    height: 9.77822,
    fill: "#276EF1",
    stroke: "black",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7723,
    y: 210.344,
    width: 10.9631,
    height: 9.78108,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5703 212.197H76.6415",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5703 215.24H76.6415",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9453 218.198H76.547",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 211.435,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 214.475,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 217.514,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.281,
    y: 211.508,
    width: 39.1998,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4561,
    y: 211.508,
    width: 84.4304,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.142,
    y: 211.508,
    width: 58.2972,
    height: 5.42767,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.0252,
    y: 241.619,
    width: 10.9602,
    height: 9.77822,
    fill: "#276EF1",
    stroke: "black",
    strokeWidth: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7723,
    y: 243.644,
    width: 10.9631,
    height: 9.78108,
    fill: "white",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5703 245.497H76.6415",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5703 248.54H76.6415",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9453 251.498H76.547",
    stroke: "#212121",
    strokeWidth: 0.857143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 244.735,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 247.775,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.0317,
    y: 250.814,
    width: 1.68861,
    height: 1.51975,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.281,
    y: 244.808,
    width: 39.1998,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.4561,
    y: 244.979,
    width: 71.3638,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.142,
    y: 244.808,
    width: 58.2972,
    height: 5.42767,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.142,
    y: 116.695,
    width: 58.2972,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.592,
    y: 116.524,
    width: 19.0973,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.142,
    y: 147.451,
    width: 58.2972,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.592,
    y: 147.28,
    width: 19.0973,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.142,
    y: 178.208,
    width: 58.2972,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.592,
    y: 178.037,
    width: 19.0973,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.142,
    y: 211.508,
    width: 58.2972,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.592,
    y: 211.508,
    width: 19.0973,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.142,
    y: 244.807,
    width: 58.2972,
    height: 5.42767,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.592,
    y: 244.978,
    width: 19.0973,
    height: 5.42767,
    fill: "#ECEEF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestopsStep5);
export default __webpack_public_path__ + "static/media/testops_step5.71fdf6a3a8709f3c2d469eda4723dd16.svg";
export { ForwardRef as ReactComponent };